export enum EstatusEmpresa {
    Prerregistro = 1,
    RegistroCompleto = 2,
    EmisorRegistrado = 3
}

export enum TipoDeComprobante {
    Factura = 1,
	NotaDeCredito,
	ComplementoDePago,
	CartaPorte
}

export enum ObjetoImpuesto {
    No = 1,
    Si,
    NoObligado,
    NoImpuesto
}

export enum MotivosCancelacion {
    ErrorConRelacion = 1,
    ErrorSinRelacion,
    OperacionNoRealizada,
    OperacionNominativa
}

export enum EstatusFolios {
    Activo = 1,
    SolicitudEnviada,
    Agotado,
    Vencido,
    Cancelado
}

export enum TipoUbicacion {
    Origen = 1,
    Destino
}

export enum CatPais {
    Mexico = 147
}